export default "__VITE_ASSET__DhXqt0pV__"